"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var rql_1 = require("../schemas/rql");
var billing_method_form_1 = require("./billing_method_form");
var billing_method_operations_1 = require("./billing_method_operations");
var react_apollo_1 = require("react-apollo");
var bind_1 = require("../bind");
var parse_graphql_errors_1 = require("@reverbdotcom/commons/dist/parse_graphql_errors");
var billing_method_placeholder_1 = require("./billing_method_placeholder");
var primary_billing_method_1 = require("./primary_billing_method");
var threeds1_container_1 = require("../credit_cards/threeds1_container");
var threeds2_billing_container_1 = require("./threeds2_billing_container");
var billing_method_form_error_1 = require("./billing_method_form_error");
var billing_method_result_1 = require("./billing_method_result");
var BillingMethod = /** @class */ (function (_super) {
    tslib_1.__extends(BillingMethod, _super);
    function BillingMethod() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            billingMethodResult: {
                adyenPaymentResult: _this.props.defaultAdyenPaymentResult,
                creditCard: null,
                billingMethodUuid: null,
            },
            isSaving: false,
            errors: [],
            showBillingMethodForm: false,
        };
        return _this;
    }
    Object.defineProperty(BillingMethod.prototype, "primaryBillingCard", {
        get: function () {
            return this.props.data.me.creditCards.find(function (creditCard) { return creditCard.primaryBilling; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingMethod.prototype, "is3ds1Required", {
        get: function () {
            return this.state.billingMethodResult.adyenPaymentResult &&
                this.state.billingMethodResult.adyenPaymentResult.paymentStatus === rql_1.core_apimessages_AdyenPaymentResult_PaymentStatus.REDIRECT_SHOPPER_REQUIRED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingMethod.prototype, "is3ds2Required", {
        get: function () {
            return this.state.billingMethodResult.adyenPaymentResult &&
                (this.state.billingMethodResult.adyenPaymentResult.paymentStatus === rql_1.core_apimessages_AdyenPaymentResult_PaymentStatus.IDENTIFY_SHOPPER_REQUIRED ||
                    this.state.billingMethodResult.adyenPaymentResult.paymentStatus === rql_1.core_apimessages_AdyenPaymentResult_PaymentStatus.CHALLENGE_SHOPPER_REQUIRED);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingMethod.prototype, "showPrimaryBillingMethod", {
        get: function () {
            var billingMethodStatus = this.props.data.me.shop.billingMethodStatus;
            var showBillingMethodForm = this.state.showBillingMethodForm;
            return !showBillingMethodForm &&
                billingMethodStatus === rql_1.core_apimessages_MyShopOnboardingResponse_BillingMethodStatus.COMPLETED &&
                this.primaryBillingCard &&
                this.state.errors.length === 0 &&
                !this.state.isSaving;
        },
        enumerable: true,
        configurable: true
    });
    BillingMethod.prototype.updateMyShopBillingMethod = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ isSaving: true, errors: [] });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.updateMyShopBillingMethod({ variables: { input: input } })];
                    case 2:
                        result = _a.sent();
                        if (result) {
                            this.setState({
                                isSaving: false,
                                showBillingMethodForm: false,
                                billingMethodResult: result.data.updateMyShopBillingMethod,
                            }, this.onUpdateBillingMethodComplete);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.setState({ isSaving: false, errors: parse_graphql_errors_1.parseGraphqlErrors(error_1) });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BillingMethod.prototype.onUpdateBillingMethodComplete = function () {
        this.handleRedirectShopperRequired();
        this.handleUpdateBillingMethodSuccess();
    };
    BillingMethod.prototype.handleUpdateBillingMethodSuccess = function () {
        if (this.props.onUpdateBillingMethodSuccess && billing_method_result_1.isBillingMethodResultSuccessful(this.state.billingMethodResult)) {
            this.props.onUpdateBillingMethodSuccess();
        }
    };
    BillingMethod.prototype.openBillingMethodForm = function () {
        this.setState({ showBillingMethodForm: true });
    };
    BillingMethod.prototype.onThreeDS2Errors = function (errors) {
        this.setState({
            errors: errors,
            billingMethodResult: {},
            isSaving: false,
        });
    };
    BillingMethod.prototype.handleRedirectShopperRequired = function () {
        if (this.props.onRedirectShopperRequired &&
            this.state.billingMethodResult.adyenPaymentResult &&
            this.state.billingMethodResult.adyenPaymentResult.paymentStatus === rql_1.core_apimessages_AdyenPaymentResult_PaymentStatus.REDIRECT_SHOPPER_REQUIRED) {
            this.props.onRedirectShopperRequired(this.state.billingMethodResult.adyenPaymentResult);
        }
    };
    BillingMethod.prototype.onThreeDS2Result = function (billingMethodResult) {
        this.setState({ billingMethodResult: billingMethodResult }, this.handleUpdateBillingMethodSuccess);
    };
    BillingMethod.prototype.renderThreeDS1Container = function () {
        var threeDsOneData = this.state.billingMethodResult.adyenPaymentResult.threeDsOneData;
        return (React.createElement(threeds1_container_1.default, { redirectUrl: threeDsOneData.redirectUrl, paReq: threeDsOneData.paReq, md: threeDsOneData.md, termUrl: threeDsOneData.termUrl }));
    };
    BillingMethod.prototype.render = function () {
        if (this.props.data.loading) {
            return (React.createElement(billing_method_placeholder_1.default, { title: this.props.title }));
        }
        if (this.props.data.error) {
            return React.createElement(billing_method_form_error_1.default, null);
        }
        if (this.is3ds1Required) {
            return this.renderThreeDS1Container();
        }
        if (this.is3ds2Required) {
            return (React.createElement(threeds2_billing_container_1.default, { title: this.props.title, billingMethodResult: this.state.billingMethodResult, onBillingMethodResult: this.onThreeDS2Result, onError: this.onThreeDS2Errors }));
        }
        if (this.showPrimaryBillingMethod) {
            return (React.createElement(primary_billing_method_1.default, { creditCard: this.primaryBillingCard, onChangeButtonClick: this.openBillingMethodForm }));
        }
        return (React.createElement(billing_method_form_1.default, { billingMethodStatus: this.props.data.me.shop.billingMethodStatus, countries: this.props.data.countries.countries, creditCards: this.props.data.me.creditCards, defaultOriginCountryCode: this.props.data.me.shop.originCountryCode, description: this.props.description, isSaving: this.state.isSaving, validationErrors: this.state.errors, updateMyShopBillingMethod: this.updateMyShopBillingMethod, user: this.props.user, title: this.props.title, showEditURL: this.props.showEditURL, returnURL: this.props.returnURL }));
    };
    tslib_1.__decorate([
        bind_1.default
    ], BillingMethod.prototype, "updateMyShopBillingMethod", null);
    tslib_1.__decorate([
        bind_1.default
    ], BillingMethod.prototype, "onUpdateBillingMethodComplete", null);
    tslib_1.__decorate([
        bind_1.default
    ], BillingMethod.prototype, "handleUpdateBillingMethodSuccess", null);
    tslib_1.__decorate([
        bind_1.default
    ], BillingMethod.prototype, "openBillingMethodForm", null);
    tslib_1.__decorate([
        bind_1.default
    ], BillingMethod.prototype, "onThreeDS2Errors", null);
    tslib_1.__decorate([
        bind_1.default
    ], BillingMethod.prototype, "onThreeDS2Result", null);
    return BillingMethod;
}(React.Component));
exports.BillingMethod = BillingMethod;
exports.default = react_apollo_1.compose(user_context_provider_1.withUserContext, billing_method_operations_1.connectUpdateMyShopBillingMethod, billing_method_operations_1.connectGetBillingMethod)(BillingMethod);
//# sourceMappingURL=billing_method.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/billing/billing_method.js
// module id = 52Cw
// module chunks = 20 21